module.exports = __webpack_public_path__ + "static/Bunderan-9a30280473837e3936d161e68950127d.png";